
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 40 38","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(1 1)","stroke":"#111","stroke-width":"2","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M5.302 19.442h2.651c2.903 0 5.568 1.292 7.07 3.535h5.303c2.569 0 5.302 2.733 5.302 5.302H13.256"}}),_c('path',{attrs:{"d":"M24.016 24.744h8.682c4.27 0 5.302 3.535 5.302 3.535l-18.738 6.845a8.27 8.27 0 01-4.405-.159L5.302 30.93"}}),_c('circle',{attrs:{"cx":"27.395","cy":"13.256","r":"4.419"}}),_c('circle',{attrs:{"cx":"15.023","cy":"4.419","r":"4.419"}}),_c('path',{attrs:{"d":"M0 17.674h5.302v14.14H0z"}})])])
          )
        }
      }
    